var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cms_icon",
    transform: "translate(20394 14441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176066",
    "data-name": "Rectangle 176066",
    width: 28,
    height: 28,
    transform: "translate(-20394 -14441)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cms",
    transform: "translate(-20400.744 -14487.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526094",
    "data-name": "Path 1526094",
    d: "M7.5,89.449v-.531a.959.959,0,0,1,.959-.959H11.97",
    transform: "translate(0 -35.946)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526095",
    "data-name": "Path 1526095",
    d: "M7.5,150.919V163.79a1.534,1.534,0,0,0,1.534,1.534",
    transform: "translate(0 -95.551)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526096",
    "data-name": "Path 1526096",
    d: "M50.956,174.45H36.29a1.551,1.551,0,0,0,1.53-1.558V161.518a.959.959,0,0,1,.959-.959H56.908a.959.959,0,0,1,.959.959v1.166",
    transform: "translate(-27.256 -104.677)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10137",
    "data-name": "Line 10137",
    y1: 2.419,
    transform: "translate(30.612 59.873)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526097",
    "data-name": "Path 1526097",
    d: "M105.416,341.492h-4.8a.533.533,0,0,1-.533-.533v-1.451a.533.533,0,0,1,.533-.533h4.8a.533.533,0,0,1,.533.533v1.451A.533.533,0,0,1,105.416,341.492Z",
    transform: "translate(-87.652 -273.584)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10138",
    "data-name": "Line 10138",
    x2: 2.805,
    transform: "translate(12.435 57.781)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10139",
    "data-name": "Line 10139",
    x2: 4.221,
    transform: "translate(12.435 59.647)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526098",
    "data-name": "Path 1526098",
    d: "M108.607,55.882V50.948a.959.959,0,0,0-.959-.959H92.329a.959.959,0,0,0-.959.959v4.934",
    transform: "translate(-79.4 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526102",
    "data-name": "Path 1526102",
    d: "M300.692,253.241V251.7a.16.16,0,0,0-.16-.16h-.967a.16.16,0,0,1-.156-.122,4.547,4.547,0,0,0-.56-1.349.159.159,0,0,1,.024-.2l.685-.685a.16.16,0,0,0,0-.226l-1.093-1.093a.16.16,0,0,0-.226,0l-.685.685a.159.159,0,0,1-.2.024,4.547,4.547,0,0,0-1.349-.56.16.16,0,0,1-.122-.156v-.967a.16.16,0,0,0-.16-.16h-1.546a.16.16,0,0,0-.16.16v.967a.16.16,0,0,1-.122.156,4.547,4.547,0,0,0-1.349.56.159.159,0,0,1-.2-.024l-.685-.685a.16.16,0,0,0-.226,0l-1.093,1.093a.16.16,0,0,0,0,.226l.685.685a.159.159,0,0,1,.024.2,4.548,4.548,0,0,0-.56,1.349.16.16,0,0,1-.156.122h-.967a.16.16,0,0,0-.16.16v1.546a.16.16,0,0,0,.16.16h.967a.16.16,0,0,1,.156.122,4.548,4.548,0,0,0,.56,1.349.159.159,0,0,1-.024.2l-.685.685a.16.16,0,0,0,0,.226l1.093,1.093a.16.16,0,0,0,.226,0l.685-.685a.159.159,0,0,1,.2-.024,4.546,4.546,0,0,0,1.349.56.16.16,0,0,1,.122.156v.967a.16.16,0,0,0,.16.16h1.546a.16.16,0,0,0,.16-.16v-.967a.16.16,0,0,1,.122-.156,4.546,4.546,0,0,0,1.349-.56.159.159,0,0,1,.2.024l.685.685a.16.16,0,0,0,.226,0l1.093-1.093a.16.16,0,0,0,0-.226l-.685-.685a.159.159,0,0,1-.024-.2,4.546,4.546,0,0,0,.56-1.349.16.16,0,0,1,.156-.122h.967A.16.16,0,0,0,300.692,253.241Z",
    transform: "translate(-266.704 -186.256)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54218",
    "data-name": "Ellipse 54218",
    cx: 1.969,
    cy: 1.969,
    r: 1.969,
    transform: "translate(26.282 64.242)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsIcon);
export default __webpack_public_path__ + "static/media/cms_icon.63ff2a1435c426240e5e0ec71736c631.svg";
export { ForwardRef as ReactComponent };